import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getDocument(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_DOCUMENT_REQUEST,
			payload: { loading: true }
		});

		const response = await API.document.getDocument(id);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DOCUMENT_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { document } = response.data;

		dispatch({
			type: ActionTypes.GET_DOCUMENT_SUCCESS,
			payload: {
				document,
				loading: false
			}
		});
	};
}

export function onDocumentSubmit({ id, fields }) {
	return async (dispatch, getState) => {
		const { document } = getState().applicationPage.documentPageReducer;
		dispatch({
			type: ActionTypes.SUBMIT_DOCUMENT_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			document: {
				...fields
			}
		};
		
		let response;
		if (id) {
			response = await API.document.updateDocument(id, body);
		} else {
			response = await API.document.createDocument(body);
		}
		
		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_DOCUMENT_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { document: newDocument } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_DOCUMENT_SUCCESS,
			payload: {
				document: newDocument,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function resetDocumentPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_DOCUMENT_PAGE
		});
	};
}

export function resetDocumentMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_DOCUMENT_META
		});
	};
}